export const CONFIG_VEHICULAR_OPTIONS = [
    ['C2', 'C2-Camión Unitario (2 llantas en el eje delantero y 4 llantas en el eje trasero)'],
    ['C2R2', 'C2R2-Camión-Remolque (6 llantas en el camión y 8 llantas en remolque)'],
    ['C2R3', 'C2R3-Camión-Remolque (6 llantas en el camión y 12 llantas en remolque)'],
    ['C3', 'C3-Camión Unitario (2 llantas en el eje delantero y 6 o 8 llantas en los dos ejes traseros)'],
    ['C3R2', 'C3R2-Camión-Remolque (10 llantas en el camión y 8 llantas en remolque)'],
    ['C3R3', 'C3R3-Camión-Remolque (10 llantas en el camión y 12 llantas en remolque)'],
    ['GPLATA', 'GPLATA-Grúa de Plataforma Tipo A'],
    ['GPLATB', 'GPLATB-Grúa de Plataforma Tipo B'],
    ['GPLATC', 'GPLATC-Grúa de Plataforma Tipo C'],
    ['GPLATD', 'GPLATD-Grúa de Plataforma Tipo D'],
    ['GPLUTA', 'GPLUTA-Grúa de Pluma Tipo A'],
    ['GPLUTB', 'GPLUTB-Grúa de Pluma Tipo B'],
    ['GPLUTC', 'GPLUTC-Grúa de Pluma Tipo C'],
    ['GPLUTD', 'GPLUTD-Grúa de Pluma Tipo D'],
    ['OTROEVGP', 'OTROEVGP-Especializado de carga Voluminosa y/o Gran Peso'],
    ['OTROSG', 'OTROSG-Servicio de Grúas'],
    ['T2S1', 'T2S1-Tractocamión Articulado (6 llantas en el tractocamión, 4 llantas en el semirremolque)'],
    ['T2S1R2', 'T2S1R2-Tractocamión Semirremolque-Remolque (6 llantas en el tractocamión, 4 llantas en el semirremolque y 8 llantas en el remolque)'],
    ['T2S1R3', 'T2S1R3-Tractocamión Semirremolque-Remolque (6 llantas en el tractocamión, 4 llantas en el semirremolque y 12 llantas en el remolque)'],
    ['T2S2', 'T2S2-Tractocamión Articulado (6 llantas en el tractocamión, 8 llantas en el semirremolque)'],
    ['T2S2R2', 'T2S2R2-Tractocamión Semirremolque-Remolque (6 llantas en el tractocamión, 8 llantas en el semirremolque y 8 llantas en el remolque)'],
    ['T2S2S2', 'T2S2S2-Tractocamión Semirremolque-Semirremolque (6 llantas en el tractocamión, 8 llantas en el semirremolque delantero y 8 llantas en el semirremolque trasero)'],
    ['T2S3', 'T2S3-Tractocamión Articulado (6 llantas en el tractocamión, 12 llantas en el semirremolque)'],
    ['T3S1', 'T3S1-Tractocamión Articulado (10 llantas en el tractocamión, 4 llantas en el semirremolque)'],
    ['T3S1R2', 'T3S1R2-Tractocamión Semirremolque-Remolque (10 llantas en el tractocamión, 4 llantas en el semirremolque y 8 llantas en el remolque)'],
    ['T3S1R3', 'T3S1R3-Tractocamión Semirremolque-Remolque (10 llantas en el tractocamión, 4 llantas en el semirremolque y 12 llantas en el remolque)'],
    ['T3S2', 'T3S2-Tractocamión Articulado (10 llantas en el tractocamión, 8 llantas en el semirremolque)'],
    ['T3S2R2', 'T3S2R2-Tractocamión Semirremolque-Remolque (10 llantas en el tractocamión, 8 llantas en el semirremolque y 8 llantas en el remolque)'],
    ['T3S2R3', 'T3S2R3-Tractocamión Semirremolque-Remolque (10 llantas en el tractocamión, 8 llantas en el semirremolque y 12 llantas en el remolque)'],
    ['T3S2R4', 'T3S2R4-Tractocamión Semirremolque-Remolque (10 llantas en el tractocamión, 8 llantas en el semirremolque y 16 llantas en el remolque)'],
    ['T3S2S2', 'T3S2S2-Tractocamión Semirremolque-Semirremolque (10 llantas en el tractocamión, 8 llantas en el semirremolque delantero y 8 llantas en el semirremolque trasero)'],
    ['T3S3', 'T3S3-Tractocamión Articulado (10 llantas en el tractocamión, 12 llantas en el semirremolque)'],
    ['T3S3S2', 'T3S3S2-Tractocamión Semirremolque-Semirremolque (10 llantas en el tractocamión, 12 llantas en el semirremolque delantero y 8 llantas en el semirremolque trasero)'],
    ['VL', 'VL-Vehículo ligero de carga (2 llantas en el eje delantero y 2 llantas en el eje trasero)'],
];

export const SUBTIPO_REM_OPTIONS = [
    ['CTR001', 'CTR001-Caballete'],
    ['CTR002', 'CTR002-Caja'],
    ['CTR003', 'CTR003-Caja Abierta'],
    ['CTR004', 'CTR004-Caja Cerrada'],
    ['CTR005', 'CTR005-Caja De Recolección Con Cargador Frontal'],
    ['CTR006', 'CTR006-Caja Refrigerada'],
    ['CTR007', 'CTR007-Caja Seca'],
    ['CTR008', 'CTR008-Caja Transferencia'],
    ['CTR009', 'CTR009-Cama Baja o Cuello Ganso'],
    ['CTR010', 'CTR010-Chasis Portacontenedor'],
    ['CTR011', 'CTR011-Convencional De Chasis'],
    ['CTR012', 'CTR012-Equipo Especial'],
    ['CTR013', 'CTR013-Estacas'],
    ['CTR014', 'CTR014-Góndola Madrina'],
    ['CTR015', 'CTR015-Grúa Industrial'],
    ['CTR016', 'CTR016-Grúa'],
    ['CTR017', 'CTR017-Integral'],
    ['CTR018', 'CTR018-Jaula'],
    ['CTR019', 'CTR019-Media Redila'],
    ['CTR020', 'CTR020-Pallet o Celdillas'],
    ['CTR021', 'CTR021-Plataforma'],
    ['CTR022', 'CTR022-Plataforma Con Grúa'],
    ['CTR023', 'CTR023-Plataforma Encortinada'],
    ['CTR024', 'CTR024-Redilas'],
    ['CTR025', 'CTR025-Refrigerador'],
    ['CTR026', 'CTR026-Revolvedora'],
    ['CTR027', 'CTR027-Semicaja'],
    ['CTR028', 'CTR028-Tanque'],
    ['CTR029', 'CTR029-Tolva'],
    ['CTR030', 'CTR030-Tractor'],
    ['CTR031', 'CTR031-Volteo'],
    ['CTR032', 'CTR032-Volteo Desmontable'],
];

export const configRequiresTrailer = (configVehicular) => {
    const config = (configVehicular || '').toUpperCase();
    return /^T\dS\d/.test(config) || /^C\dR\d/.test(config);
};
